import React from "react";
import PropTypes from "prop-types";
import withStoryRenderer from "../with-story-renderer";
import { trackVideoStory } from "../../utils/index";
import styles from "./video-renderer.module.scss";
import { useStoryNavigation } from "../../utils/reel-navigation-context";

export const VideoRender = React.forwardRef(({ story, config }, ref) => {
  const { storiesLength, storyIndex } = useStoryNavigation();

  React.useEffect(() => {
    const onVideoPlayHandler = () => {
      trackVideoStory(storyIndex, storiesLength, config?.header);
    };

    ref.current?.addEventListener("play", onVideoPlayHandler, {
      once: true,
    });

    return () => {
      ref.current?.removeEventListener("play", onVideoPlayHandler);
    };
  }, [story.url]);

  return (
    <video
      className={styles.reelVideo}
      crossOrigin="anonymous"
      data-testid="reel-video-player"
      key={story.url}
      muted
      playsInline
      ref={ref}
    >
      <source src={story.url} type="video/mp4" />
      {story.tracks?.map((track) => {
        const { src } = track;
        if (!src) return;

        return <track key={src} kind="captions" src={src} default />;
      })}
    </video>
  );
});

const VideoRenderer = {
  renderer: withStoryRenderer(VideoRender),
  tester: (story) => ({
    condition: story.type === "videoReel",
    priority: 4,
  }),
};

VideoRender.displayName = "VideoRender";

VideoRender.propTypes = {
  story: PropTypes.shape({
    type: PropTypes.oneOf(["videoReel"]).isRequired,
    url: PropTypes.string.isRequired,
    duration: PropTypes.number,
    tracks: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string.isRequired,
        srclang: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        default: PropTypes.bool.isRequired,
      })
    ),
    poster: PropTypes.string,
    cta: PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default VideoRenderer;
